/** @type {import('next').NextConfig} */
const nextConfig = {
  productionBrowserSourceMaps: true, // Enable source maps for Lighthouse
  images: {
    domains: ["image.lexica.art", "lexica.art", "media.licdn.com"],
  },
  experimental: {
    scrollRestoration: true, // Ensures scroll resets on navigation
  },
};

export const ALLOWED_IMAGE_HOSTNAMES = nextConfig.images.domains;

export default nextConfig;
